import React from 'react';
import { Route, Routes } from 'react-router';
import { useLocalStorageState } from 'ahooks';
import { AccountPersistInfo } from 'Internal.CommonAPI';
import ErrorBoundary from 'Common/pages/error';

import Datev from './screens/Datev';
import Callback from './screens/Callback';

const DatevSection = () => {
  const [account] = useLocalStorageState<AccountPersistInfo>('account');
  return (
    <>
      {account !== undefined && (
        <Routes>
          <Route
            path="home"
            element={account.country === 'DE' ? <Datev /> : <ErrorBoundary />}
          />
          <Route
            path="callback"
            element={
              account.country === 'DE' ? <Callback /> : <ErrorBoundary />
            }
          />
        </Routes>
      )}
    </>
  );
};

export default DatevSection;
